import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { jsPDF } from 'jspdf';
import RobotoRegular from '@themes/architectui/src/assets/jspdf-fonts/roboto-regular-normal.js';
import RobotoBold from '@themes/architectui/src/assets/jspdf-fonts/roboto-regular-bold.js';

// FUTURIBLE: this component will be deleted by the new preview of an invoice.
@Component({
  name: 'bpc-html-to-pdf',
  components: {},
})
export default class HtmlToPdf extends Vue {
  @Prop(Boolean) readonly autoDownload: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideDownloadButton: boolean;
  @Prop({ type: String, default: 'download.pdf' }) readonly documentName: string;
  @Prop({ type: String, default: 'global.actions.download' }) readonly printButtonLabel: string;

  jsPDF: InstanceType<typeof jsPDF>;

  printing: boolean = false;

  constructor() {
    super();
    this.resetJsPdf();
  }

  mounted() {
    this.random = this.generateUUIDv4();
    this.maybeDownload();
  }

  maybeDownload() {
    if (this.autoDownload) {
      this.$nextTick().then(() => {
        this.printContent();
      });
    }
  }

  resetJsPdf() {
    this.jsPDF = new jsPDF({
      format: 'a4',
      orientation: 'p',
      unit: 'mm',
    });
    this.jsPDF.addFileToVFS('Roboto-Regular.ttf', RobotoRegular);
    this.jsPDF.addFileToVFS('Roboto-Bold.ttf', RobotoBold);
    this.jsPDF.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
    this.jsPDF.addFont('Roboto-Bold.ttf', 'Roboto', 'bold');
    this.jsPDF.setFont('Roboto');
  }

  generateUUIDv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  random = 'random-code';

  get printElementId(): string {
    return `print-element-${this.random}`;
  }

  async printContent() {
    this.$emit('download');
  }
}
